<template>
  <div>
    <modal
      :show-modal="show_terms"
      @close="show_terms=false"
    >
      <template v-slot:header>
        <h5>Terms and Conditions</h5>
      </template>
      <terms />
    </modal>
    <modal
      :show-modal="show_privacy"
      @close="show_privacy=false"
    >
      <template v-slot:header>
        <h5>Privacy Statement</h5>
      </template>
      <privacy />
    </modal>
    <footer class="footer-wrapper bg-gray">
      <div class="footer-columns" />
      <div class="footer-columns footer-links">
        <ul>
          <li>
            <a
              href="#"
              @click.prevent="show_terms=true"
            >Terms of Services</a>
          </li>
          <li>
            <a
              href="#"
              @click.prevent="show_privacy=true"
            >Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div class="footer-columns social">
        <div class="header-email">
          <a href="mailto:talktous@sidianbank.co.ke"><span class="fa fa-envelope" />talktous@sidianbank.co.ke</a>
        </div>
        <div class="header-social">
          <ul>
            <li>
              <a
                href="https://twitter.com/SidianBank"
                target="_blank"
                class="fa fa-twitter"
              />
            </li>
            <li>
              <a
                href="https://web.facebook.com/SidianBank/"
                target="_blank"
                class="fa fa-facebook"
              />
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/sidian-bank-limited-b9510a101/"
                target="_blank"
                class="fa fa-linkedin"
              />
            </li>
            <li>
              <a
                href=" https://www.instagram.com/sidianbank/"
                target="_blank"
                class="fa fa-instagram"
              />
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
    import Terms from "@/components/Guest/Terms.vue";
    import Privacy from "@/components/Guest/Privacy.vue";
    export default {
        components: {
            Terms,
            Privacy
        },
        data() {
            return {
                show_terms: false,
                show_privacy: false,
            }
        }
    }
</script>

